import React, { useState, useEffect, useMemo } from 'react'
import withAppconfig from '../AppContext'
import SimpleView from './SimpleView'
import HorizontalView from './HorizontalView'
import VerticalView from './VerticalView2'
import FlightView from './FlightView'
import NowAvailable from './NowAvailable'
import moment from 'moment-timezone'
import { getOffset } from './ViewUtils'
const TIMEZONEOFFSET = getOffset('Europe/Helsinki')


const filterVacancies = (vacancies, filters, resourceleadtimes, servertime) => {
  if (!filters && !resourceleadtimes) return vacancies
  if (filters.zenniz) {
    vacancies
      .map((v) => {
        v.courts = v.courts.filter((v) => v.zenniz)
        if (v.courts.length > 0) {
          return v
        } else {
          return null
        }
      })
      .filter((v) => v)
  }
  if(resourceleadtimes) {
    vacancies
      .map((v) => {
          // filter out resources that need more lead time than current time and starttime difference
          const n = moment(servertime).add(Math.abs(TIMEZONEOFFSET), 'minutes')
          v.courts = v.courts.filter((c) => { 
            if (c.id && resourceleadtimes[c.id]) {
              const leadtime = resourceleadtimes[c.id]
              const start = moment.utc(v.start)
              const diff = start.diff(n, 'minutes')
              if (diff >= leadtime) {
                return true
              } else {
                return false
              }
            } else {
              return true
            }
          })
          if (v.courts.length > 0) {
            return v
          } else {
            return null
          }
      })
      .filter((v) => v)
  }

  return vacancies
}

function ReservationCalendar({
  view,
  appconfig,
  // dailyFreeTimes,
  servertime,
  selectedCategory,
  onUnreservableClick,
  selectedday,
  vacancies,
  filters
}) {
  const [viewStyle, setViewStyle] = useState('simple') // 'simple' | 'horizontal' | 'vertical' | 'flight' | 'lastminute'

  console.log('ReservationCalendar props', {
    view,
    servertime,
    selectedCategory,
    selectedday,
  })

  const [dailyFreeTimes, setDailyFreeTimes] = useState([])
  const [appConf, setAppConf] = useState(appconfig)

  useMemo(() => {
    console.log('ReservationCalendar useMemo', selectedday, vacancies, filters, appconfig ? appconfig.resourceleadtimes : null)
    if(!selectedday) return
    const dateindex = moment.utc(selectedday).format('YYYYMMDD')
    if (vacancies && vacancies[dateindex]) {
      const v = vacancies[dateindex]
      if (v) {
        let fv = filterVacancies(v, filters, appconfig ? appconfig.resourceleadtimes : null, servertime)
        console.log('ReservationCalendar useMemo setDailyFreeTimes')
        setDailyFreeTimes(fv)
      } else {
        setDailyFreeTimes([])
      }
    } 
  }, [vacancies, selectedday, filters, servertime, appconfig])

  useMemo(() => {
    if (JSON.stringify(appConf) !== JSON.stringify(appconfig)) {
      setAppConf(appconfig)
    }
  }, [appconfig])

  useEffect(() => {
    console.log('ReservationCalendar view changed', view)
    setViewStyle(view)
  }, [view])

  let currentTime = null
  if (selectedday && servertime) {
    if (servertime.format('YYYY-MM-DD') === selectedday) {
      currentTime = servertime.format('HH:00')
    }
  }

  if (viewStyle === 'simple') {
    return (
      <SimpleView
        dailyFreeTimes={dailyFreeTimes}
        currentTime={currentTime}
        selectedvenue={selectedCategory}
        onUnreservableClick={onUnreservableClick}
        appconfig={appConf}
      />
    )
  } else if (viewStyle === 'horizontal') {
    return (
      <HorizontalView
        dailyFreeTimes={dailyFreeTimes}
        currentTime={currentTime}
        selectedvenue={selectedCategory}
        onUnreservableClick={onUnreservableClick}
        appconfig={appConf}
      />
    )
  } else if (viewStyle === 'vertical') {
    return (
      <VerticalView
        dailyFreeTimes={dailyFreeTimes}
        currentTime={currentTime}
        selectedvenue={selectedCategory}
        onUnreservableClick={onUnreservableClick}
        appconfig={appConf}
      />
    )
  } else if (viewStyle === 'flight') {
    return (
      <FlightView
        dailyFreeTimes={dailyFreeTimes}
        currentTime={currentTime}
        selectedvenue={selectedCategory}
        onUnreservableClick={onUnreservableClick}
        appconfig={appConf}
      />
    )
  } else if (viewStyle === 'lastminute') {
    return (
      <NowAvailable
        dailyFreeTimes={[]}
        selectedvenue={selectedCategory}
        weather={null}
        viewEmptyTimes={false}
        showWeek={false}
        appconfig={appConf}
      />
    )
  } else {
    return <div>Unknown view style</div>
  }
}

export default withAppconfig(ReservationCalendar)
